'use client';
import { TabCardAccordionProps } from '@/components/Tabs/TabCard';
import { TabCardAccordion } from '@/components/Tabs';
import remote from './remote.png';

const tabItem: TabCardAccordionProps = {
  image: remote,
  imageAlt: 'Team member on a video conference call, demonstrating remote work',
  imagePosition: 'left',
  accordionData: [
    {
      title: 'Constant collaboration',
      body: 'We maintain a standard workday and some meetings across time zones to ensure strong collaboration. We also prioritize clear written communication to respect your schedule and workflow and allow you to focus and contribute effectively.',
    },
    {
      title: 'Autonomy & trust',
      body: "We empower you to own your work and deliver results. Whether you're closing a deal, launching a feature, or creating compelling content, we trust your expertise and provide support when needed.",
    },
    {
      title: 'Strong community',
      body: 'We foster connection through virtual events, regular check-ins, and opportunities for in-person meetups so you can build relationships with colleagues across all departments.',
    },
  ],
};

export default function FeatureTabsWrapper() {
  return <TabCardAccordion {...tabItem} />;
}
